import React from "react";

const ActionsButtons = (actionButtonsProps) => {
  return (
    <>
  {actionButtonsProps.actions === ""? 
      <button
        className={`nav-action-buttons-wrapper ${
          actionButtonsProps.isDark
            ? "action-buttons-wrapper-dark"
            : "action-buttons-wrapper-light"
        } ${actionButtonsProps.isLarge ? "large-buttons" : "medium-buttons"} ${
          actionButtonsProps.isWatchNow
            ? "watch-now-wrapper"
            : "arrow-button-wrapper"
        }`}
        style={{
          borderColor: actionButtonsProps.borderColor,
          backgroundColor: actionButtonsProps.bgColor,
        }}
      >
        <div
          style={{ color: actionButtonsProps.fontColor }}
          className="nav-action-label"
        >
          {actionButtonsProps.label}
        </div>
        <img
          src={actionButtonsProps.actionButtonIcon}
          alt="Jameel Motors"
          className="nav-action-icon"
        />
      </button> :
      <button
      className={`nav-action-buttons-wrapper ${
        actionButtonsProps.isDark
          ? "action-buttons-wrapper-dark"
          : "action-buttons-wrapper-light"
      } ${actionButtonsProps.isLarge ? "large-buttons" : "medium-buttons"} ${
        actionButtonsProps.isWatchNow
          ? "watch-now-wrapper"
          : "arrow-button-wrapper"
      }`}
      style={{
        borderColor: actionButtonsProps.borderColor,
        backgroundColor: actionButtonsProps.bgColor,
      }}
      
      onClick={actionButtonsProps.actions}z
    >
      <div
        style={{ color: actionButtonsProps.fontColor }}
        className="nav-action-label"
      >
        {actionButtonsProps.label}
      </div>
      <img
        src={actionButtonsProps.actionButtonIcon}
        alt="Jameel Motors"
        className="nav-action-icon"
      />
    </button>}
    </>
  );
};

export default ActionsButtons;
